import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { LoadConversationAction, SendMessageAction, LoadMessagesAction, EnteredConversationAction, LeftConversationAction } from './conversation.actions';

@Injectable()
export class ConversationStoreDispatcher {
    constructor(private store: Store<AppState>) { }

    public loadConversation(conversationID: string) {
        this.store.dispatch(new LoadConversationAction(conversationID));
    }

    public sendMessage(conversationID: string, message: string) {
        this.store.dispatch(new SendMessageAction(conversationID, message));
    }

    public loadMessages(conversationID: string) {
        this.store.dispatch(new LoadMessagesAction(conversationID));
    }

    public enteredConversation(conversationID: string) {
        this.store.dispatch(new EnteredConversationAction(conversationID));
    }

    public leftConversation(conversationID: string) {
        this.store.dispatch(new LeftConversationAction(conversationID));
    }
}
